//let globalConfig = config;

//const isSSRBuild = process.env.VUE_APP_USE_SSR;

require("./we.scss");

export default {};
